import {useAxiosClient} from "~/use/axios/client";
import {AssortmentApi, GmModelLibraryModelsAssortmentModel} from "~/gen/openapi/sblService";
import {keepPreviousData, useQuery, UseQueryOptions} from "@tanstack/vue-query";
import {MS_HOUR} from "~/constants/time";
import {useOnline} from "@vueuse/core";

export const useAssortmentService = () => {
    const { axiosClient } = useAxiosClient()
    const assortmentApi = new AssortmentApi(undefined, '', axiosClient.value)
    const isOnline = useOnline()

    const getAssortmentsQueryOptions: UseQueryOptions<Array<GmModelLibraryModelsAssortmentModel>> = {
        queryKey: ['assortmentGetAssortments'],
        queryFn: async () => {
            try {
                return (await assortmentApi.assortmentGetAssortments())?.data as GmModelLibraryModelsAssortmentModel[]
            } catch (e) {
                return Promise.reject(e)
            }
        },
        staleTime: 2 * MS_HOUR,
        placeholderData: keepPreviousData,
        networkMode: 'offlineFirst',
        gcTime: Infinity,
        enabled: isOnline
    }

    const assortmentsQuery = () => {
        return useQuery(getAssortmentsQueryOptions)
    }

    return {
        getAssortmentsQueryOptions,
        assortmentsQuery,
    }

}